module.exports = __webpack_public_path__ + "img/add-people.c9372a1c.svg";